<div class="translate-classification-modal">
    <h2 md-dialog-title><b>{{translationKey}}</b> - Associated Sporting Events</h2>
    <md-dialog-content>
      <app-spinner *ngIf="loading"></app-spinner>
      <table *ngIf="!loading">
        <thead>
          <tr>
            <th>Id</th>
            <th>Creation Date</th>
            <th>Name</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let sportingEvent of sportingEvents" >
            <td>
              {{sportingEvent.id}}               
            </td>
            <td>{{sportingEvent.creationDate | date: 'dd/MM/yyyy'}}</td>
            <td style="vertical-align:center">
              {{sportingEvent.value}}
            </td>
          </tr>
        </tbody>
      </table>
      <br>
    </md-dialog-content>
  </div>


// WEBPACK FOOTER //
// ./src/app/modals/translate-classification-modal/translate-classification-modal.component.html